import { Outlet } from "react-router-dom";

const Vaccine = () => {

  return <Outlet />
}

export default Vaccine;